import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { Icon, Button,Label,Segment, ButtonGroup  } from 'semantic-ui-react';
import {Message, Grid} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import * as qs from "query-string";

import 'semantic-ui-css/semantic.min.css';
import { Helmet } from 'react-helmet'
import {AuthService} from "../../services/auth-service";



class cotsqueue extends Component {

    constructor(props) {
        super(props);
        this.authServices = new AuthService();

        this.state = {
            cotQueue : this.authServices.getCotQueue(),
            params: qs.parse(this.props.location.search),

        };

      
    }


    componentDidMount = () => {
        if(this.state.params.qid !== undefined)
            {
                if(this.state.params.queue === "true")
                {
                this.notify("Successfully saved, this request has not been submitted to Inenco and can be continued later from the Account Management > Saved site/meter change requests option. Your ref ID is : " + this.state.params.qid + "",false,false);
                }else
                {
                    this.notify("Successfully Submitted! Your ref ID is : " + this.state.params.qid + "",false,false);

                }
            }
    }

    translateSiteChangeStatus = (status) => 
    {
            if(status === "removeMeter")
            {
                return "Remove Meter"
            }else if(status === "moveOut")
            {
                return "Move Out"
            }else if(status === "newMeter")
            {
                return "New Meter"
            }else  if(status === "other")
            {
                return "Other"
            }else 
            {
                return status
            }
    }

    handleRestartNewSite = (name, value) => {
  

        this.props.history.push("/sites?queue="+value.id);
        window.location.reload();
    
    };

    handleRestartSiteUpdate = (name, value) => {
       
     this.props.history.push("/site?siteKey=" + value.value + "&queue="+ value.id);
            window.location.reload();
    };

    handleRemoveQueueItem = (name, value) => {
       

       this.authServices.removeCotQueueItem(value.id,value.value).then( () =>
       {
        this.setState({
            cotQueue: this.authServices.getCotQueue(),
            refreshState:!this.state.refreshState})  

        //window.location.reload();
       })
       

    };

    notify = (message, error = false, refresh=false) => {
        if (error) {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 50,
                autoClose: false
            });
        } else if (refresh){
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
               autoClose: false,
               onClose: () => {
                //this.props.history.push("/");
                //window.location.reload();
               }
            });
        } else {
            toast.success(message, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: false,
                closeOnClick: false
            });
        }
    }
   
    render() {

        const { cotQueue } = this.state;

        // Check if the cotQueue is empty and display a message
        if (cotQueue.length === 0) {
            return (
                <div className='main-container'>
                    <Helmet>
                        <title>Inenco Portal | Site/Meter Requests</title>
                    </Helmet>
                    <Grid padded stackable columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                <h2>Site/Meter Requests</h2>
                                <Message info>
                                    <Message.Header>No Resumable Site Requests</Message.Header>
                                    <p>You currently have no resumable site/meter requests. Begin a new request from the Sites page to see it here.</p>
                                </Message>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            );
        }


        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Site/Meter Requests</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Site/Meter Requests</h2>
                        </Grid.Column>
                       
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                        <div className="dropdown">
                            <div className="cot-user-content">
                            <React.Fragment>
                                <h3>Resumable Site Requests</h3>
                            <div className="repeater-body">
                                        {this.state.cotQueue.map((x,index) =>
                                             <Segment key={index}>
                                                
<Label>
                                                        {this.translateSiteChangeStatus(x.changeReqested) + " - " +  ((x.siteAddress !== undefined &&  x.siteAddress.length >= 80) ? x.siteAddress.substring(0, 80) + '...' : x.siteAddress )}   
                                                         {" - Expected Change Date :" + x.changeDate }  
                                                        </Label>
                                                      
                                                        <ButtonGroup floated="right" >
                                                            <Button
                                                                negative
                                                                id={x.id}
                                                                value={x.siteId}
                                                                onClick={this.handleRemoveQueueItem}
                                                            >                        <Icon name='trash' />
                                                            </Button>
                                                            {x.siteId === 'New' ? 
                                                                <Button 
                                                                positive  
                                                                id={x.id}
                                                                value={x.siteId}
                                                                onClick={this.handleRestartNewSite}>Resume</Button>
                                                                : <Button positive
                                                                id={x.id}
                                                                value={x.siteId}
                                                                onClick={this.handleRestartSiteUpdate}>Resume</Button>
                                                                
                                                        }   
                                                       </ButtonGroup>    
                                                    
                                                 
                                                </Segment>

                                        )}
                                    </div>
                                </React.Fragment>
                            </div>
                        </div>
                        </Grid.Column>

                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default withRouter(cotsqueue);